import {
  Box,
  Stack,
  zIndex,
  Container as SharedContainer
} from '@viveaesthetics/shared'
import styled from 'styled-components'

import { InternalLink } from '../InternalLink/InternalLink'

export const HEADER_HEIGHT = 5.6
export const SUBHEADER_HEIGHT = 4.4

export const HeaderWrapper = styled(Stack)<{
  $hasStaticBackground?: boolean
  id: string
}>`
  position: sticky;
  top: 0;
  z-index: ${zIndex};

  background-color: ${({ theme, $hasStaticBackground }) =>
    $hasStaticBackground
      ? theme.styleVariables.ColorTokens.staticBg
      : 'transparent'};

  transition: background-color 0.3s;
`

export const NewTherapistHeaderWrapper = styled(HeaderWrapper)`
  box-shadow: ${({ theme }) => theme.styleVariables.Shadows.ds1};
`

export const HeaderContent = styled(Box)`
  height: ${HEADER_HEIGHT}rem;
`

export const SubheaderContent = styled(Box)`
  display: inline-flex;
  height: ${SUBHEADER_HEIGHT}rem;
  overflow-x: auto;
  box-shadow: ${({ theme }) => theme.styleVariables.Shadows.ds1};
`

export const LinkWrapper = styled(InternalLink)`
  display: flex;
`

export const DefaultLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;

  position: relative;
  overflow-y: auto;

  height: 100vh;
  gap: 0;
  clip-path: inset(0 0 0 0);

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0;
  }
`

export const DefaultLayoutContentWrapper = styled.div<{
  backgroundImage: string
}>`
  margin-top: -${HEADER_HEIGHT + SUBHEADER_HEIGHT}rem;
  padding-top: ${HEADER_HEIGHT + SUBHEADER_HEIGHT}rem;

  display: flex;
  flex-direction: column;
  flex: 1;

  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-repeat: no-repeat;
  background-size: contain;

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    background-size: auto;
  }
`

export const FooterWrapper = styled(Box)`
  border-top: 1px solid
    ${({ theme }) => theme.styleVariables.ColorTokens.staticBorder};
  display: flex;
  justify-content: center;
`

export const FooterContent = styled(Stack)`
  max-width: 128rem;
  width: 100%;
`

export const FooterLinksWrapper = styled(Stack)`
  width: 18rem;
  align-items: flex-start;
  padding-top: ${({ theme }) => theme.styleVariables.Sizes.Spacings.spacing8};
`

export const Container = styled(SharedContainer)`
  @media ${({ theme }) => theme.mediaQueries.mobile} {
    padding-left: ${({ theme }) =>
      theme.styleVariables.Sizes.Spacings.spacing16};
    padding-right: ${({ theme }) =>
      theme.styleVariables.Sizes.Spacings.spacing16};
  }
`
